import { Api } from '@/services/Api'

export default {
  searchAddress (text) {
    return Api().get('/util/address/', { params: { q: text } })
  }
}
